export class HeatmapParams {
  private static readonly _DEFAULT_COLOR = 'viridis';
  private static readonly _DEFAULT_OPACITY = 0.7;
  private static readonly _DEFAULT_MIN_PERCENTILE = 0.0;
  private static readonly _DEFAULT_MAX_PERCENTILE = 100.0;
  private static readonly _DEFAULT_ACTIVE = false;
  private static readonly _DEFAULT_NEEDS_REFRESH = false;

  active: boolean;
  needsRefresh: boolean;
  color: string;
  opacity: number;
  minPercentile: number;
  maxPercentile: number;

  constructor() {
    this.active = HeatmapParams._DEFAULT_ACTIVE;
    this.needsRefresh = HeatmapParams._DEFAULT_NEEDS_REFRESH;
    this.color = HeatmapParams._DEFAULT_COLOR;
    this.opacity = HeatmapParams._DEFAULT_OPACITY;
    this.minPercentile = HeatmapParams._DEFAULT_MIN_PERCENTILE;
    this.maxPercentile = HeatmapParams._DEFAULT_MAX_PERCENTILE;
  }
}
